import React from 'react'

import { useNavigation } from '@react-navigation/native'
import { useIsSsoLoggedInUser } from '@zet/common/hooks/useIsSsoLoggedInUser'
import { colors } from '@zet/design-system'
import { Stack, XStack } from '@zet/design-system/layout'
import { B2, SH1 } from '@zet/design-system/typography'
import { useUserContext } from '@zet/feature-user'

import useStore from '../../store'
import { getGreetings } from '../../utils'
import { getName } from '../../utils/stringConversion'
import { DsaInformation } from '../dsaInformation'
import { ProfileImage } from './profileImage'
import { RightSideElement } from './rightSideElement'

const HomeScreenHeader = () => {
  const navigation = useNavigation()
  const { data } = useUserContext()
  const { user } = useStore()
  const { isSsoLoggedInUser } = useIsSsoLoggedInUser()

  const name = user?.name || data?.name
  const image = data?.imageUrl

  const goToProfile = () => {
    if (!isSsoLoggedInUser) navigation.navigate('AccountDetails')
  }

  return (
    <>
      <XStack
        className="flex-row items-center justify-between px-3 py-3"
        style={{ backgroundColor: colors.tertiary[100] }}
      >
        <XStack className="items-center">
          <ProfileImage name={name} image={image} onPress={goToProfile} />
          <Stack className="ml-2">
            <B2 className="text-neutral-white100">{getGreetings()}</B2>
            <SH1 numberOfLines={2} className="text-neutral-white100">
              {getName(name)}
            </SH1>
          </Stack>
        </XStack>
        <RightSideElement />
      </XStack>

      {!isSsoLoggedInUser && <DsaInformation />}
    </>
  )
}

export default HomeScreenHeader
